<script lang="ts">
    import {InforcePolicy} from "../../models/InforcePolicy";
    import {getInsuranceTypes, getReplacementCompanies} from "../../services/ApplicationDataService";

    export let inforcePolicy: InforcePolicy;
    let insuranceTypes = getInsuranceTypes();
   const replacementCompanies  =  getReplacementCompanies()
    const currentYear = new Date().getFullYear();

    const answerQuestion = (value: boolean) => {
       inforcePolicy.toBeReplaced = value;
    }
</script>
<div class="text-section">
    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Company Name:</label>
            <select bind:value={inforcePolicy.companyName} required>
              <option value="">Select One</option>
              {#each replacementCompanies as company}
                <option value={company}>{company}</option>
              {/each}
            </select>
             {#if inforcePolicy.companyName == "" }
                          <span class="invalidlabel">Valid company name is required</span>
                        {/if}
        </div>
    </div>
    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Year Issued:</label>
            <input bind:value={inforcePolicy.yearIssued} type="number" min="1900" max={currentYear}/>
            {#if inforcePolicy.yearIssued < 1900 || inforcePolicy.yearIssued > currentYear }
              <span class="invalidlabel">Valid year is required</span>
            {/if}
        </div>
    </div>
    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Face Amount:</label>
            <input bind:value={inforcePolicy.faceAmount} type="number" min="0" max="9999999999" pattern="\d*"/>
             {#if inforcePolicy.faceAmount < 0 || inforcePolicy.faceAmount >  9999999999}
                          <span class="invalidlabel">Face amount cannot be over $9,999,999,999</span>
                        {/if}

        </div>
    </div>


<!-- change to yes/no -->
    <div class="control-row">
        <div class="control-group-horizontal">
            <div class="yes-no-question">
                <label>Replacing:</label>
                <div class="question-button-container">
                    <button type="button" class="{inforcePolicy.toBeReplaced === true ? 'question-button selected' : 'question-button'}" on:click={() => answerQuestion(true)}>Yes</button>
                    <button type="button" class="{inforcePolicy.toBeReplaced === false ? 'question-button selected' : 'question-button'}" on:click={() => answerQuestion(false)}>No</button>
                </div>

            </div>

        </div>
    </div>


    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Policy Number:</label>
            <input bind:value={inforcePolicy.policyNumber} />
        </div>
    </div>

    <div class="control-row">
        <div class="control-group-horizontal">
            <label>Insurance Type:</label>
            <select bind:value={inforcePolicy.insuranceType} >
                <option value=''> Select Insurance Type </option>
                {#each insuranceTypes as insuranceType}
                    <option value={insuranceType.key}> {insuranceType.type}
                    </option>
                {/each}
            </select>
<!--            <input bind:value={inforcePolicy.insuranceType} />-->
        </div>
    </div>

</div>

<style lang="scss">
  @use "../../../component_scss_library/questions";
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/forms" as forms;
  .yes-no-question-container {
    display: flex;
    flex-direction: column;
  }
  .yes-no-question {
    display: flex;
    flex-direction: row;
  }

  .disclosures-container {
    display: flex;
    flex-direction: row;
    margin: 20px 0 10px 0;
  }

  .question-button-container {
    width: 160px;
  }

</style>
